import { baseApi } from "../baseApi";

export const termsandconditionApi = baseApi.injectEndpoints({
     endpoints: (builder) => ({
    getTermsandCondition: builder.query({
      query: (params) => ({
        url: `/api/resource/Terms and Conditions`,
      }),
    }),
  }),
});

export const {useGetTermsandConditionQuery} = termsandconditionApi;

